import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=1eaba710&scoped=true&"
import script from "./CardLink.vue?vue&type=script&lang=ts&"
export * from "./CardLink.vue?vue&type=script&lang=ts&"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=1eaba710&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaba710",
  null
  
)

export default component.exports